import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import OverlayTool from './components/OverlayTool';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import GalleryManager from './components/Manager';
import CarouselAds from './components/CarouselAds';
import Products from './components/Products';
import { AuthProvider } from './context/AuthContext';
import { OverlayToolProvider } from './context/OverlayToolContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLogin from './components/AdminLogin';
import AdsManager from './components/AdsManager';
import AdminDashboard from './components/AdminDashboard';
import AdminLayout from './components/AdminLayout';
import SectionTransition from './components/SectionTransition';
import ProductsManager from './components/ProductsManager';
import DigitalPresentationCard from './components/DigitalPresentationCard';
import AdminQuoteImages from './components/AdminQuoteImages';
import AboutManager from './components/AboutManager';

import './styles/index.css';

function MainWebsite() {
  const [showAds, setShowAds] = useState(false);

  const location = useLocation();

  // Scroll to section based on URL
  useEffect(() => {
    const section = location.pathname.replace('/', '');
    if (section) {
      const el = document.getElementById(section);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  // Show ads on initial load
  useEffect(() => {
    const adsShown = sessionStorage.getItem('adsShown');
    if (!adsShown) {
      setShowAds(true);
      sessionStorage.setItem('adsShown', 'true');
    }
  }, []);

  return (
    <>
      <CarouselAds
        isVisible={showAds}
        onClose={() => setShowAds(false)}
      />
      <Navbar onShowAds={() => setShowAds(true)} />
      <Hero />
      <About />
      <Services />
      <Products />
      <SectionTransition
        top="#fff"
        bottom="linear-gradient(to right, black, #101828)"
      />
      <OverlayTool />
      <Footer />
      <ScrollToTop />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      {/* OverlayToolProvider enables cross-component product injection */}
      <OverlayToolProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<MainWebsite />} />
              <Route path="/inicio" element={<MainWebsite />} />
              <Route path="/nosotros" element={<MainWebsite />} />
              <Route path="/servicios" element={<MainWebsite />} />
              <Route path="/productos" element={<MainWebsite />} />
              <Route path="/logotool" element={<MainWebsite />} />

              {/* Admin login - public */}
              <Route path="/admin/login" element={<AdminLogin />} />

              {/* Protected admin routes */}
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout>
                      <AdminDashboard />
                    </AdminLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/about"
                element={
                  <ProtectedRoute>
                    <AboutManager />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/ads"
                element={
                  <ProtectedRoute>
                    <AdsManager />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/gallery"
                element={
                  <ProtectedRoute>
                    <GalleryManager />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/products"
                element={
                  <ProtectedRoute>
                    <ProductsManager />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/quotes"
                element={
                  <ProtectedRoute>
                    <AdminQuoteImages />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/api/*"
                element={<Navigate to="/admin/login" replace />}
              />

              {/* Catch all - redirect to home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </Router>
      </OverlayToolProvider>
    </AuthProvider>
  );
}

export default App;
